<template>
	<div class="addEdit-block" :style='{"padding":"30px","fontSize":"16px","color":"#666","background":"none"}'>
		<el-form
			:style='{"border":"1px solid #eee","padding":"30px","boxShadow":"0 0px 0px rgba(64, 158, 255, .3)","fontSize":"inherit","borderRadius":"6px","background":"#fff"}'
			class="add-update-preview"
			ref="ruleForm"
			:model="ruleForm"
			:rules="rules"
			label-width="150px"
		>
			<!-- 基本信息（只读） -->
			<el-divider content-position="left">基本信息</el-divider>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' label="工号" prop="gonghao">
				<el-input v-model="ruleForm.gonghao" placeholder="工号" readonly></el-input>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' label="姓名" prop="xingming">
				<el-input v-model="ruleForm.xingming" placeholder="姓名" readonly></el-input>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' label="图片数量">
				<el-tag type="success" size="medium">{{imageCount}}张</el-tag>
				<span style="margin-left: 10px; color: #999; font-size: 14px;">（限制1-3张）</span>
			</el-form-item>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' label="上传时间" v-if="ruleForm.uploadTime">
				<el-input v-model="ruleForm.uploadTime" readonly></el-input>
			</el-form-item>
			
			<!-- 合同图片 -->
			<el-divider content-position="left">合同图片</el-divider>
			
			<el-form-item :style='{"color":"inherit","margin":"0 0 20px 0","fontSize":"inherit"}' label="合同图片" prop="images">
				<div style="display: flex; flex-wrap: wrap; gap: 15px;">
					<!-- 已有图片 -->
					<div v-for="(img, index) in imageList" :key="index" style="position: relative; width: 150px; height: 150px; border: 1px solid #ddd; border-radius: 6px; overflow: hidden;">
						<img 
							v-if="img.substring(0,4)=='http'" 
							:src="img" 
							style="width: 100%; height: 100%; object-fit: cover; cursor: pointer;"
							@click="previewImage(index)">
						<img 
							v-else 
							:src="$base.url + img" 
							style="width: 100%; height: 100%; object-fit: cover; cursor: pointer;"
							@click="previewImage(index)">
						
						<!-- 图片序号 -->
						<span style="position: absolute; top: 5px; left: 5px; background: rgba(0,0,0,0.6); color: white; padding: 3px 8px; border-radius: 3px; font-size: 12px;">{{index + 1}}</span>
						
						<!-- 删除按钮 -->
						<div v-if="type!='info'" style="position: absolute; top: 5px; right: 5px; background: rgba(255,0,0,0.8); color: white; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 16px;"
							@click="removeImage(index)">
							×
						</div>
					</div>
					
					<!-- 添加图片按钮 -->
					<div v-if="type!='info' && imageCount < 3" 
						style="width: 150px; height: 150px; border: 2px dashed #ddd; border-radius: 6px; display: flex; align-items: center; justify-content: center; cursor: pointer; background: #fafafa;"
						@click="showUploadDialog = true">
						<div style="text-align: center;">
							<i class="el-icon-plus" style="font-size: 30px; color: #999;"></i>
							<div style="margin-top: 10px; color: #999; font-size: 14px;">添加图片</div>
						</div>
					</div>
				</div>
				
				<div v-if="imageList.length === 0" style="color: #999; padding: 20px; text-align: center; background: #f9f9f9; border-radius: 6px; margin-top: 10px;">
					<i class="el-icon-picture-outline" style="font-size: 40px; color: #ddd;"></i>
					<div style="margin-top: 10px;">暂无合同图片</div>
				</div>
			</el-form-item>
			
			<!-- 操作提示 -->
			<el-alert
				v-if="type!='info'"
				title="操作提示"
				type="info"
				:closable="false"
				style="margin-bottom: 20px;">
				<template slot>
					<p style="margin: 5px 0;">• 点击图片可以预览</p>
					<p style="margin: 5px 0;">• 点击"×"按钮可以删除图片</p>
					<p style="margin: 5px 0;">• 点击"+"可以添加新图片</p>
					<p style="margin: 5px 0;">• 合同图片数量限制为1-3张</p>
				</template>
			</el-alert>
			
			<!-- 按钮 -->
			<el-form-item :style='{"width":"100%","padding":"0","margin":"0","fontSize":"inherit","textAlign":"center"}' class="btn">
				<el-button class="btn3" v-if="type!='info'" type="success" @click="onSubmit" :loading="submitLoading">
					<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
					保存修改
				</el-button>
				<el-button class="btn5" type="info" @click="back()">
					<span class="icon iconfont icon-fanhui" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
					{{ type=='info' ? '返回' : '取消' }}
				</el-button>
			</el-form-item>
		</el-form>
		
		<!-- 图片上传对话框 -->
		<el-dialog title="上传图片" :visible.sync="showUploadDialog" width="500px" :before-close="handleUploadClose">
			<file-upload
				tip="点击上传合同图片"
				action="file/upload"
				:limit="3 - imageCount"
				:multiple="false"
				:fileUrls="''"
				@change="handleImageUpload"
			></file-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showUploadDialog = false">取消</el-button>
			</div>
		</el-dialog>
		
		<!-- 图片预览对话框 -->
		<el-dialog title="图片预览" :visible.sync="imagePreviewVisible" width="60%">
			<div style="text-align: center;">
				<img 
					v-if="previewImageUrl.substring(0,4)=='http'" 
					:src="previewImageUrl" 
					style="max-width: 100%; max-height: 600px;" />
				<img 
					v-else 
					:src="$base.url + previewImageUrl" 
					style="max-width: 100%; max-height: 600px;" />
			</div>
			<div style="text-align: center; margin-top: 20px;">
				<el-button @click="prevImage" :disabled="previewIndex === 0">上一张</el-button>
				<span style="margin: 0 20px;">{{ previewIndex + 1 }} / {{ imageList.length }}</span>
				<el-button @click="nextImage" :disabled="previewIndex === imageList.length - 1">下一张</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			ruleForm: {
				id: '',
				gonghao: '',
				xingming: '',
				images: '',
				imageCount: 0,
				uploadTime: ''
			},
			imageList: [],
			rules: {
				images: [
					{ required: true, message: '请至少上传1张合同图片', trigger: 'change' }
				]
			},
			type: '',
			submitLoading: false,
			showUploadDialog: false,
			imagePreviewVisible: false,
			previewImageUrl: '',
			previewIndex: 0,
			ro: {
				gonghao: true,
				xingming: true
			}
		};
	},
	computed: {
		imageCount() {
			return this.imageList.length;
		}
	},
	props: ["parent"],
	methods: {
		init(id, type) {
			this.type = type || '';
			this.ruleForm.id = id || 0;
			
			if (this.ruleForm.id) {
				this.getInfo();
			}
		},
		
		// 获取信息
		getInfo() {
			this.$http({
				url: `hetong/info/${this.ruleForm.id}`,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.ruleForm = data.data;
					// 解析图片列表
					if (this.ruleForm.images) {
						this.imageList = this.ruleForm.images.split(',');
					} else {
						this.imageList = [];
					}
				}
			});
		},
		
		// 图片上传成功
		handleImageUpload(fileUrls) {
			if (fileUrls) {
				const newImages = fileUrls.split(',');
				// 添加新图片到列表
				this.imageList = this.imageList.concat(newImages);
				// 更新表单
				this.ruleForm.images = this.imageList.join(',');
				this.ruleForm.imageCount = this.imageList.length;
				// 关闭上传对话框
				this.showUploadDialog = false;
				this.$message.success('图片上传成功');
			}
		},
		
		// 关闭上传对话框
		handleUploadClose(done) {
			done();
		},
		
		// 删除图片
		removeImage(index) {
			this.$confirm('确定要删除这张图片吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.imageList.splice(index, 1);
				this.ruleForm.images = this.imageList.join(',');
				this.ruleForm.imageCount = this.imageList.length;
				this.$message.success('删除成功');
			}).catch(() => {});
		},
		
		// 预览图片
		previewImage(index) {
			this.previewIndex = index;
			this.previewImageUrl = this.imageList[index];
			this.imagePreviewVisible = true;
		},
		
		// 上一张
		prevImage() {
			if (this.previewIndex > 0) {
				this.previewIndex--;
				this.previewImageUrl = this.imageList[this.previewIndex];
			}
		},
		
		// 下一张
		nextImage() {
			if (this.previewIndex < this.imageList.length - 1) {
				this.previewIndex++;
				this.previewImageUrl = this.imageList[this.previewIndex];
			}
		},
		
		// 提交表单
		onSubmit() {
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					// 验证图片数量
					if (this.imageList.length < 1) {
						this.$message.error('请至少上传1张合同图片');
						return;
					}
					if (this.imageList.length > 3) {
						this.$message.error('合同图片最多3张');
						return;
					}
					
					this.submitLoading = true;
					
					// 更新图片数据
					this.ruleForm.images = this.imageList.join(',');
					this.ruleForm.imageCount = this.imageList.length;
					
					// 调用后端接口更新图片
					this.$http({
						url: "hetong/updateImages",
						method: "post",
						data: {
							id: this.ruleForm.id,
							images: this.ruleForm.images,
							imageCount: this.ruleForm.imageCount
						}
					}).then(({ data }) => {
						this.submitLoading = false;
						if (data && data.code === 0) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.back();
								}
							});
						} else {
							this.$message.error(data.msg);
						}
					}).catch(() => {
						this.submitLoading = false;
					});
				}
			});
		},
		
		// 返回
		back() {
			this.parent.showFlag = true;
			this.parent.addOrUpdateFlag = false;
			this.parent.search();
		}
	}
};
</script>

<style lang="scss" scoped>
.el-divider__text {
	font-weight: bold;
	font-size: 16px;
}
</style>




